module.exports = __webpack_public_path__ + "static/img/banner.b995ab8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner.png
// module id = P07D
// module chunks = 12